import { ViewContainerRef } from '@angular/core';
import { CruiseService } from '../services/cruise.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';

declare var $: any;
declare var moment: any;
declare var window: any;
@Component({
    selector: 'bookingReport',
    templateUrl: './bookingReport.component.html',
    styleUrls: ['./bookingReport.component.css'],
    providers: [CruiseService, DatePipe]
})
export class BookingReportComponent implements OnInit {
    public dellist: any = ""; public descbookingList: any[]; public cancelledList: any[];
    public bookingList: any[]; public cruisebookingList: any[];
    public statusList: any[]; public bookinghotelList: any[];
    public menuList: any[]; public bookingPackageList: any[];
    public airlineList: any[]; public ledgerList: any[]; public orgledgerList: any[]; public agencyList: any[];
    public creditupdateRequest: any[];
    public creditupdateList: any[];
    public depositupdateList: any[];
    public insuranceList: any[];
    public AgentsList: any[];
    public agentuid: any = "";
    public listactive: any = "";
    public Airlineint: any = '';
    public ResAirline: any[];
    public code: any = "";
    public summaryList: any[];
    public agent: any = {};
    public reports: any = {};
    public Updatemsg: any = "";
    public uid: any = "";
    public sids: any = "";
    public reportname: any = "";
    public reportType: any = "";
    public fromDate: any;
    public toDate: any;
    public dates: any;
    public logintype: any = "";
    public agentcode: any = "";
    public agentid: any = "";
    public amountcredit: any = "";
    public banknarration: any = "";
    public executivename: any = "";
    public agencyname: any = "";
    public creditamount: any = "";
    public updateid: any;
    //private baseUrl: any = AppConstants.siteUrl;
    private siteUrl: any = "";
    public ticketUrl: any = "";
    public invoiceUrl: any = "";
    public merchantsetup: any = {};
    private systemsetup: any = {};
    public trans: any = "";
    private itinerary: any = "";
    private baseURL: any = '';
    public agentrole: any = "";
    private hdnTransferPickDate: any = "";
    public reportList: any = [];
    //AppConstants.baseUrl + "/bookingReport";;
    public agentImport: any = ""; public PNR: any = ""; public paxName: any = "";
    public LoginIdint: any = "";
    public sid: any = ""; public creditSid: any = "";
    public InsCompamy: any = "";

    public ResagentImport: any[];
    public OrgAgentsList: any[]; public OrgCustomersList: any[]; public CustomersList: any[];
    public agentbooking: any = "";
    //public LoginIdint: any = "";
    public Resagentbooking: any[];

    public daterange: any = {
        label: 'Select Date'
    };
    public options: any = {
        maxDate: moment(),
        autoUpdateInput: false,
        "locale": { "format": "DD/MM/YYYY" }
    };
    public selectedDate(value: any, datepicker?: any) {
        // this is the date  selected
        console.log(value);

        // any object can be passed to the selected event and it will be passed back here
        datepicker.start = value.start;
        datepicker.end = value.end;

        // use passed valuable to update state
        this.daterange.start = value.start;
        this.daterange.end = value.end;
        this.daterange.label = this.datePipe.transform(this.daterange.start.toDate(), "dd/MM/yyyy")
            + ' - ' + this.datePipe.transform(this.daterange.end.toDate(), "dd/MM/yyyy");
        this.fromDate = this.datePipe.transform(this.daterange.start.toDate(), "dd-MM-yyyy");
        this.toDate = this.datePipe.transform(this.daterange.end.toDate(), "dd-MM-yyyy");
    }

    constructor(@Inject(PLATFORM_ID) private platformId: Object, private CruiseService: CruiseService, private route: Router, private toastr: ToastrService, private datePipe: DatePipe, public vcr: ViewContainerRef, private sanitizer: DomSanitizer,
        private _location: Location, private activeroute: ActivatedRoute, platformLocation: PlatformLocation, private titleService: Title, private meta: Meta) {

        this.baseURL = (platformLocation as any).location.origin;

        if (isPlatformBrowser(this.platformId)) {
            if (sessionStorage.getItem("logindata")) {
                this.agent = JSON.parse(JSON.parse(sessionStorage.getItem("logindata")));
                this.logintype = this.agent.Type;
                this.agentcode = this.agent.CompanyCode;
                this.agentid = this.agent.AgentUserLoginId;
                this.agentrole = this.agent.roles;
            }
            else {
                this.toastr.warning("You don't have permission to view this...!");
                setTimeout(() => {
                    this.route.navigate([""]);
                }, 2000);
            }
        }
    }

    ngOnInit() {
        window.scrollTo(0, 0);
        this.removetxnsession();
        // this.titleService.setTitle("Book Cruise Tour Packages with Akbar Travels");
        this.meta.addTag({ name: 'author', content: 'http://www.influencetechnolabs.com/' });

        this.fromDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
        this.toDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
        // $('#dataPicker').val(this.fromDate + ' / ' + this.toDate);
        this.dates = this.fromDate + ' / ' + this.toDate;
        this.daterange.start = this.fromDate;
        this.daterange.end = this.toDate;
        this.daterange.label = this.fromDate
            + ' - ' + this.toDate;
    }

    ngAfterViewInit() {
        setTimeout(() => {
            // $('#dataPicker').daterangepicker({
            //     maxDate: moment(),
            //     autoUpdateInput: false,
            //     "locale": { "format": "DD/MM/YYYY" }
            // }, (start, end) => {
            //     $('#dataPicker').val(start.format('DD-MM-YYYY') + ' / ' + end.format('DD-MM-YYYY'));
            //     this.fromDate = start.format('DD-MM-YYYY');
            //     this.toDate = end.format('DD-MM-YYYY');
            // });
        }, 2000);
    }

    onlyAlphabets(e: any) {
        try {
            if (window.event) {
                var charCode = window.event.keyCode;
            }
            else if (e) {
                var charCode = e.which;
            }
            else { return true; }
            if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || (charCode == 32))
                return true;
            else
                return false;
        }
        catch (err) {
        }
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    updatesubPlan(event) {
        this.reportType = event.target.value;
    }

    removetxnsession() {
        if (isPlatformBrowser(this.platformId)) {
            var n = sessionStorage.length;
            while (n--) {
                var key = sessionStorage.key(n);
                if (/txn:/.test(key)) {
                    sessionStorage.removeItem(key);
                }
            }
        }
    }
    makeItBlankAirline(event) {
        $(event.target).val("");
        this.sid = "";
        this.code = "";
    }

    setAirline(Name, code) {
        this.Airlineint = Name;
        this.code = code;
        this.ResAirline = [];
    }

    showCruiseItinerary(bookinglist, txId) {
        sessionStorage.removeItem("txn:" + txId);
        if (this.baseURL.toLowerCase().indexOf("akbar") > -1) { this.itinerary = environment.portalURL + "/cruise/itinerary/" + txId + "/success"; }
        else {
            this.itinerary = "/cruise/itinerary/" + txId + "/success";
        }
        this.route.navigate([]).then(result => { window.open(this.itinerary, '_blank'); });
    }

    onNavigate(insurl) {
        const url = insurl;
        window.open(url, '_blank');
    }

    backClicked() {
        this._location.back();
    }

    search() {
        if (this.agentrole == "") {
            if (this.reportType == "StatusReport") {
                this.getStatusList();
                this.reportname = "Status Report";
            }
            if (this.reportType == "CruiseBookingReport") {
                this.getCruiseBookingList();
                this.reportname = "Cruise Booking Report";
            }
            if (this.reportType == "LedgerStatement") {
                this.getLedgerStatementList();
                this.reportname = "Ledger Statement Report";
            }
        }
        else {
            if (this.reportType == "StatusReport" && this.agentrole.indexOf("StatusReport") > -1) {
                this.getStatusList();
                this.reportname = "Status Report";
            }
            if (this.reportType == "CruiseBookingReport") {
                this.getCruiseBookingList();
                this.reportname = "Cruise Booking Report";
            }
            if (this.reportType == "LedgerStatement") {
                this.getLedgerStatementList();
                this.reportname = "Ledger Statement Report";
            }
        }
    }

    setLoginNamebooking(Name, id, sid) {
        this.agentbooking = Name;
        this.LoginIdint = id;
        this.sid = sid;
        this.Resagentbooking = [];
    }

    makeItBlankbooking(event) {
        $(event.target).val("");
        this.agentbooking = "";
        this.sid = "";
    }

    setLoginNameimport(Name, id, sid) {
        this.agentImport = Name;
        this.LoginIdint = id;
        this.sid = sid;
        this.ResagentImport = [];
    }
    makeItBlankimport(event) {
        $(event.target).val("");
        this.agentImport = "";
        this.sid = "";
    }

    getCruiseBookingList() {
        this.CruiseService.getCruiseBookingReport(this.fromDate, this.toDate, this.agent.CompanyCode, this.agent.Type, this.agent.AgentUserLoginId).subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    this.cruisebookingList = resp.bookingReport;
                }
            }, error => {
                console.log("getBookingReport Error .....");
            }
        )
    }

    exportToExcel() {
        var data = [];
        if (this.reportType == "StatusReport") {
            data = this.statusList;
        }
        if (this.reportType == "CreditUpdateRequest") {
            data = this.creditupdateRequest;
        }
        if (this.reportType == "CreditUpdateList") {
            data = this.creditupdateList;
        }
        if (this.reportType == "DepositUpdateRequest") {
            data = this.depositupdateList;
        }
        if (this.reportType == "DepositUpdateList") {
            data = this.depositupdateList;
        }
        if (this.reportType == "BookingReport") {
            data = this.bookingList;
        }
        if (this.reportType == "AirlineWiseSummary") {
            data = this.airlineList;
        }
        if (this.reportType == "LedgerStatement") {
            data = this.ledgerList;
        }
        if (this.reportType == "InsuranceReport") {
            data = this.insuranceList;
        }
        if (this.reportType == "AgentsList") {
            data = this.AgentsList;
        }
        if (this.reportType == "CustomersList") {
            data = this.CustomersList;
        }
        if (this.reportType == "CruiseBookingReport") {
            data = this.cruisebookingList;
        }
        if (this.reportType == "CancelledTktList") {
            data = this.cancelledList;
        }
        if (this.reportType == "RefundTktList") {
            data = this.cancelledList;
        }
        if (this.reportType == "AgencySummary") {
            data = this.agencyList;
        }
        var randomnumber = Math.floor(Math.random() * 100000001)
        // this.exportService.exportExcel(data, this.reportType + "_" + randomnumber);
    }

    getStatusList() {
        var mydate = $("#dataPicker").val();
        if (mydate != "") {
            var bdates = mydate.split('/');
        }
        this.CruiseService.getstatusReport(bdates[0].trim(), bdates[1].trim(), this.agent.CompanyCode, this.agent.Type, this.agent.AgentUserLoginId).subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    this.statusList = resp.statusReport;
                }
            }, error => {
                console.log("getStatusList Error .....");
            }
        )
    }

    Reset() {
        this.ledgerList = this.orgledgerList;
    }

    GetagentwiseLIST() {
        this.AgentsList = [];
        for (let list of this.OrgAgentsList) {
            if (list.ActiveFlag == this.InsCompamy) {
                this.AgentsList.push(list);
            }
        }

    }
    ResetLIST() {
        this.AgentsList = this.OrgAgentsList;
    }
    Resetbooking() {
        this.bookingList = this.descbookingList;
        this.Airlineint = "";
        this.code = "";
        this.agentbooking = "";
    }

    getLedgerStatementList() {
        var mydate = $("#dataPicker").val();
        if (mydate != "") {
            var bdates = mydate.split('/');
        }
        this.CruiseService.getledgerStatement(bdates[0].trim(), bdates[1].trim(), this.agent.CompanyCode, this.agent.Type, this.agent.AgentUserLoginId).subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    // var resp1 = JSON.parse(JSON.parse(JSON.stringify(data)).d).summary;
                    this.ledgerList = resp.ledgerStatement;
                    this.orgledgerList = resp.ledgerStatement;
                    // this.summaryList = resp1;
                }
            }, error => {
                console.log("getLedgerStatementList Error .....");
            }
        )
    }
}
